import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Eee1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1xaNO3jM1salmunfEA3w1YB6-EuBqeNEP/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1k260-A6M5msSn15xckjZ7Yk_xsxLDFvB/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1yOQSroJwSxWSIWr1Air7LZ984dFQaQ7p/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">EEE Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Eee1;
